import Icon from '../components/Icon.vue'

Icon.register({"arrow-circle-up":{"width":512,"height":512,"paths":[{"d":"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM151.6 284.9L224 209.4V392C224 405.3 234.7 416 248 416H264C277.3 416 288 405.3 288 392V209.4L360.4 284.9C369.7 294.6 385.2 294.8 394.7 285.3L405.6 274.3C415 264.9 415 249.7 405.6 240.4L273 107.7C263.6 98.3 248.4 98.3 239.1 107.7L106.3 240.4C96.9 249.8 96.9 265 106.3 274.3L117.2 285.3C126.8 294.8 142.3 294.6 151.6 284.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-up.js
// module id = 4pN0
// module chunks = 0